import React from "react";
import { CircularProgress, Box, Typography } from "@mui/material";

const GlobalLoader = ({ label = "Processing...", inDialog = false }) => (
  <Box
    sx={{
      position: inDialog ? "absolute" : "fixed",
      top: 0,
      left: 0,
      width: inDialog ? "100%" : "100vw",
      height: inDialog ? "100%" : "100vh",
      backgroundColor: "rgba(0, 0, 0, 0.2)",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 20000,
    }}
  >
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: 2,
        backgroundColor: "#ffffff",
        padding: 3,
        borderRadius: 2,
        boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
        minWidth: 200,
      }}
    >
      <CircularProgress />
      <Typography
        variant="subtitle1"
        sx={{ fontWeight: 500, textAlign: "center" }}
      >
        {label}
      </Typography>
    </Box>
  </Box>
);

export default GlobalLoader;
